import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LangChangeEvent } from '@ngx-translate/core';
import { TranslationService } from 'src/metronic/core/_base/layout';
import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';

@Component({
  selector: 'rek-header-card',
  templateUrl: './header-card.component.html',
  styleUrls: ['./header-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderCardComponent implements OnInit {
  @Input() readonly enrollmentInfo: string;

  language: string = LanguageType.Polish;

  constructor(private translationService: TranslationService) { }

  ngOnInit() {
    this.initOnLanguageChanges();
  }


  private initOnLanguageChanges(): void {
    this.translationService.onLanguageChange()
      .subscribe((lce: LangChangeEvent) =>
        this.language = LanguageType[lce.lang]
      );
  }
}
